<template>
<div class="relatorio">
    <div class="descTable">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <h2 style="color:white; box-shadow: 1px 1px 8px black;">
            <svg
              style="width:24px;height:24px;margin-left: 87px;margin-bottom: -4px;"
              viewBox="0 0 24 24"
            >
              <path
                fill="#fff"
                d="M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"
              ></path>
            </svg>
            Informe de Rendimentos
          </h2>
        </v-flex>
      </v-layout>
    </div>

    <v-card flat style="width: 90%;margin: 0 auto 40px auto;padding: 41px 41px 0px 41px;background-color: #efefef;" id="">
        <div v-if="successMessage">
            <v-alert
                :value="true"
                type="success"
                :dismissible="true"
                style="padding:5px;"
            >
              {{successMessage}}    
            </v-alert>
        </div>

        <div v-if="errorMessage">
            <v-alert
                :value="true"
                type="error"
                :dismissible="true"
                style="padding:5px;"
            >
              {{errorMessage}}    
            </v-alert>
        </div>

        <div class="informe-rendimentos-div-file">
            <span class="inputFile">
                <label for="file-upload" class="custom-file-upload" @click="resetInfos()">
                    <v-icon>mdi-file</v-icon>
                    {{  path ? path : 'Selecione um arquivo'}}
                </label>

                <small>
                    {{fileText}}
                    <span class="teal_bold">{{path}}</span>
                </small>
                <input
                    type="file"
                    @change="setFile($event)"
                    name="file-upload"
                    value="file"
                    @keypress.enter.prevent
                    @keydown.enter.prevent
                    id="file-upload"
                    
                />
            </span>
            <v-btn v-if="file && file.name" :disabled="isFileUploading ? true : false" style="background: teal; color: white;" @click="handleUploadFile">{{ isFileUploading ? 'Enviando...' : 'Enviar arquivo' }}</v-btn>
        </div>

        <div style="display: flex; align-items: center">
            <v-select v-model="tipo" clearable :items="['pdf_beneficiario', 'pdf_completo']" label="Tipo"></v-select>
            <v-select v-model="status_arquivo" clearable style="margin-left: 30px;" :items="['pendente', 'processando', 'finalizado', 'falha']" label="Status do Arquivo"></v-select>
            <v-select v-model="status_email" clearable style="margin-left: 30px;" :items="['pendente', 'processando', 'enviado']" label="Status do E-mail"></v-select>
            <v-text-field return-masked-value mask="##/##/####" clearable style="margin-left: 30px;" v-model="dataIni" label="Data Inicio"></v-text-field>
            <v-text-field return-masked-value mask="##/##/####" clearable style="margin-left: 30px;" v-model="dataFim" label="Data Fim"></v-text-field>
        </div>

        <div>
            <v-card>
                <v-card-title>
                    <v-btn style="background: teal; color: white;" @click="buscaInformeRendimentos">Buscar / Atualizar</v-btn>
                    <v-btn style="background: teal; color: white;" @click="vOcrClear">Limpar filtros</v-btn>
                    <v-btn v-if="body && body.length > 0" style="background: teal; color: white;" @click="exportatExcel">Exportar</v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Pesquisar"
                    single-line
                    hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                    :headers="headers"
                    :items="body"
                    :search="search"
                    hide-actions
                    :pagination.sync="pagination"
                    class="elevation-1"
                    :loading="isLoading"
                    id="table"
                >
                    <v-progress-linear slot="progress" color="teal" height="20" indeterminate style="z-index: 3;"></v-progress-linear>

                    <template slot="no-data">
                        <v-alert :value="true" color="indigo darken-4" icon="info" outline>
                        <article v-if="isLoading">Motor Fiscal está buscando as informações</article>
                        <article v-if="!isLoading">
                            Dados não encontrados
                        </article>
                        </v-alert>
                    </template>
          
                    <template v-if="!isLoading" v-slot:items="props">
                        <tr :style="{ 'background': props.item.pathPdf ? '' : '#ffe5e3' }">
                            <td class="text-xs-center"><span class="ocrLink" @click="handleOpenFile(props.item)">Visualizar</span></td>
                            <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.data_registro ? `${new Date(props.item.data_registro).toLocaleDateString('pt-BR')} ${new Date(props.item.data_registro).toLocaleTimeString('pt-BR')}` : '' }}</td>
                            <td style="white-space: nowrap;" class="text-xs-center">
                                <v-chip
                                    v-if="props.item.tipo_arquivo"
                                    small
                                    :color="props.item.tipo_arquivo ? 
                                    props.item.tipo_arquivo === 'pdf_beneficiario' ? 
                                    'brown darken-2' : 
                                    props.item.tipo_arquivo === 'pdf_completo' ? 
                                    'brown darken-4' : '' : ''"
                                    text-color="white"
                                >
                                    <span>{{ props.item.tipo_arquivo ? props.item.tipo_arquivo : '' }}</span> 
                                </v-chip>
                            </td>
                            <td class="text-xs-center">
                                <v-chip
                                    v-if="props.item.status_ocr"
                                    small
                                    :color="props.item.status_ocr ? 
                                    props.item.status_ocr === 'finalizado' ? 
                                    'green' : 
                                    props.item.status_ocr === 'pendente' ? 
                                    'orange' : 
                                    props.item.status_ocr === 'processando' ? 
                                    'blue' :
                                    props.item.status_ocr === 'falha' ? 
                                    'red' : 'grey darken-3'
                                    : 'grey darken-3'"
                                    text-color="white"
                                >
                                    <span>{{ props.item.status_ocr ? props.item.status_ocr : 'Não possui' }}</span> 
                                </v-chip>
                            </td>
                            
                            <td style="white-space: nowrap;" class="text-xs-center">
                                <v-chip
                                    small
                                    v-if="props.item.status_envio_email"
                                    :color="props.item.status_envio_email ? 
                                    props.item.status_envio_email === 'enviado' ? 
                                    'green' : 
                                    props.item.status_envio_email === 'processando' ? 
                                    'blue' :
                                    props.item.status_envio_email === 'pendente' ? 
                                    'orange' : '' : ''"
                                    text-color="white"
                                >
                                    <span>{{ props.item.status_envio_email ? props.item.status_envio_email : '' }}</span> 
                                </v-chip>
                            </td>
                            <td style="white-space: nowrap;" class="text-xs-center">{{props.item.cnpj_beneficiario != undefined ? (props.item.cnpj_beneficiario.length > 11 ? props.item.cnpj_beneficiario.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : props.item.cnpj_beneficiario.replace(/^(\d{3})(\d{3})(\d{3})(\d)/,"$1.$2.$3-$4") ) : ''}}</td>
                            <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.razao_beneficiario }}</td>
                            <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.email_beneficiario }}</td>
                            <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.data_email && props.item.data_email !== 'None' ? `${new Date(props.item.data_email).toLocaleDateString('pt-BR')} ${new Date(props.item.data_email).toLocaleTimeString('pt-BR')}` : '' }}</td>
                            <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.ano_calendario }}</td>
                        </tr>
                    </template>

                    <template v-slot:no-results>
                        <v-alert :value="true" color="error" icon="warning">
                        "{{ search }}" não encontrado.
                        </v-alert>
                    </template>

                    <template slot="pageText" slot-scope="props">
                        <strong>
                        Exibindo {{ props.pagination.page }} - {{ 14 }} do total de {{ props.pages }}
                        <span>Notas</span>
                        </strong>
                    </template>
                </v-data-table>

                <div class="text-xs-center pt-2">
                    <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
                </div>
            </v-card>
        </div>
    </v-card>

    <v-dialog
        @keydown.esc="dialog = false"
        v-model="dialog"
        fullscreen
        :lazy="true"
    >
        <v-card>
            <v-card-title
                class="headline darkBlue"
                text-color="white"
                style="color: white;"
            >
                Informe de rendimentos
                <v-spacer></v-spacer>
                <v-btn icon dark @click.native="dialog = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text id="tst">
                <iframe style="width: 100%; height: 90vh;" :src="'data:application/pdf;base64,'+encodeURIComponent(this.pdf)" frameborder="0"/> 
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    flat
                    @click="dialog = false"
                >
                    Fechar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <div v-if="isFileLoading" class="cont-ocr"></div>
</div>
</template>
<script>

import { informeRendimentosUploadFileApi, getInformeRendimentosApi, informeRendimentosBuscaArquivoApi } from './InformeRendimentosService';

export default {
    mounted: function() {
        this.vOcrUpdate();
    },
    data() {
        return {
            mask: { cnpjTomador: "", cnpjPrestador: "" },
            successMessage: '',
            isBtnLoading: false,
            tipo: '',
            status_arquivo: '',
            status_email: '',
            dataIni: '',
            dataFim: '',
            isLoading: false,
            dialog: false,
            search: '',
            pagination: {
                rowsPerPage: 10,
                totalItems: 0,
            },
            selected: [],
            headers: [
                { text: 'PDF', align: 'center', sortable: false, value: '' },
                { text: 'Data registro', align: 'center', value: 'data_registro' },
                { text: 'Tipo arquivo', align: 'center', value: 'tipo_arquivo' },
                { text: 'Status OCR', align: 'center', value: 'status_ocr' },
                { text: 'Status envio e-mail', align: 'center', value: 'status_envio_email' },
                { text: 'CNPJ beneficiario', align: 'center', value: 'cnpj_beneficiario' },
                { text: 'Razão beneficiario', align: 'center', value: 'razao_beneficiario' },
                { text: 'E-mail beneficiario', align: 'center', value: 'email_beneficiario' },
                { text: 'Data envio e-mail', align: 'center', value: 'data_email' },
                { text: 'Ano calendario', align: 'center', value: 'ano_calendario' },
            ],
            body: [],
            editedItem: {},
            editedIndex: -1,
            fileText: "Nenhum arquivo selecionado",
            path: "",
            file: {},
            token: "",
            isFileUploading: false,
            errorMessage: '',
            pdf: '',
            isFileLoading: false,
        };
    },
    computed: {
        pages () {
            if (this.pagination.rowsPerPage == null ||
                this.pagination.totalItems == null
            ) return 0

            return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
        },
    },
    mounted() {
        this.token = this.$router.currentRoute.params.token;
        this.buscaInformeRendimentos();
    },
    methods: {
        exportatExcel: function() {
            let tab_text="<table border='2px'><tr bgcolor='#87AFC6'>";
            var j=0;
            let tab = document.querySelector('.v-datatable');
            let sa;
            let aux = tab.rows[2].innerHTML;

            aux = aux.replace('<td class="text-xs-center"><span data-v-', '');
            const componenteId = aux.substr(0, 8);

            for(j = 0 ; j < tab.rows.length ; j++) {    
                const pdf = '<th role="columnheader" scope="col" aria-label="PDF: Not sorted." aria-sort="none" class="column text-xs-center">PDF</th>'

                if(!tab.rows[j].innerHTML.includes('<th colspan="10" class="column"></th>')) {
                    tab_text=tab_text+tab.rows[j].innerHTML
                        .replace(pdf, '')
                        .replaceAll('arrow_upward', '')
                        .replaceAll(`<td class="text-xs-center"><span data-v-${componenteId}="" class="ocrLink">Visualizar</span></td>` , '')
                        .replaceAll(`<td data-v-${componenteId}="" class="text-xs-center"><span data-v-${componenteId}="" class="ocrLink">Visualizar</span></td>`, '')
                        +"</tr>";
                }
            }

            tab_text=tab_text+"</table>";
            tab_text= tab_text.replace(/<A[^>]*>|<\/A>/g, "");
            tab_text= tab_text.replace(/<img[^>]*>/gi,"");
            tab_text= tab_text.replace(/<input[^>]*>|<\/input>/gi, "");

            var ua = window.navigator.userAgent;
            var msie = ua.indexOf("MSIE "); 

            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
            {
                txtArea1.document.open("txt/html","replace");
                txtArea1.document.write(tab_text);
                txtArea1.document.close();
                txtArea1.focus(); 
                sa=txtArea1.document.execCommand("SaveAs",true,"Say Thanks to Sumit.xls");
            }  
            else
                // sa = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text));
                sa = window.open('data:application/vnd.ms-excel,' + escape(tab_text));

            return (sa);
        },
        resetInfos() {
            this.file = {};
            let file = document.querySelector("#file-upload");
            file.value = "";

            this.path = "";
            this.fileText = "Nenhum arquivo selecionado";
        },
        setFile: function(e) {
            this.path = "";
            if (e.target.type == "file") {
                if (e.target.files.length > 0) {
                    this.fileText = "Arquivo selecionado: ";
                    this.path = e.target.files[0].name;
                    this.file = e.target.files[0]
                } else {
                    this.fileText = "Nenhum arquivo selecionado";
                }
            }else {
                return;
            }
        },
        vOcrClear() {
            this.dataIni = '';
            this.dataFim = '';
            this.tipo = '';
            this.status_arquivo = '';
            this.status_email = '';
        },
        handleUploadFile: function() {
            if(!this.file || !this.file.name) return;

            this.isFileUploading = true;
            var reader = new FileReader();
            reader.onload = async () => {
                const name = this.file.name;
                const base64 = reader.result.split('data:application/pdf;base64,')[1];

                const json = {
                    NOME_ARQUIVO: name,
                    ARQUIVO: base64,
                }
            

                const response = await informeRendimentosUploadFileApi(json, this.token);

                this.isFileUploading = false;

                if(response && response.STATUS === 'SUCESSO') {
                    this.resetInfos()
                    this.successMessage = 'Arquivo enviado!';

                    setTimeout(() => {
                        this.successMessage = '';
                    }, 5000);
                }else {
                    this.errorMessage = 'Erro ao enviar o arquivo.';

                    setTimeout(() => {
                        this.errorMessage = '';
                    }, 5000);
                }

            }
            reader.readAsDataURL(this.file);
        },
        buscaInformeRendimentos: async function() {
            this.isLoading = true;
            const informeDataInicial = this.dataIni && this.dataIni.length === 10 ? this.dataIni : '';
            const informeDataFinal = this.dataFim && this.dataFim.length === 10 ? this.dataFim : '';
            const informeTipo = this.tipo ? this.tipo : '';
            const informeStatusArquivo = this.status_arquivo ? this.status_arquivo : '';
            const informeStatusEmail = this.status_email ? this.status_email : '';

            const response = await getInformeRendimentosApi(informeDataInicial, informeDataFinal, informeTipo, informeStatusArquivo, informeStatusEmail, this.token);

            if(response) {
                this.body = response.rendimentos;
                this.pagination.totalItems = response.rendimentos.length;
                this.isLoading = false;
            }else {
                this.isLoading = false;
                this.errorMessage = 'Erro ao buscar os dados.';

                setTimeout(() => {
                    this.errorMessage = '';
                }, 5000);
            }
            this.isLoading = false;
        },
        handleOpenFile: async function(item) {
            if (item && item._id && item.pathPdf) {
                this.isFileLoading = true;
                const response = await informeRendimentosBuscaArquivoApi(item._id, this.token);
                this.isFileLoading = false;
                if(response && response.pdfBase64) {
                    this.pdf = response.pdfBase64;
                    this.dialog = true;
                }else {
                    this.errorMessage = 'Arquivo não encontrado.';

                    setTimeout(() => {
                        this.errorMessage = '';
                    }, 5000);
                }
            }else {
                this.errorMessage = 'Arquivo não encontrado.';

                setTimeout(() => {
                    this.errorMessage = '';
                }, 5000);
            }
            // if (this.nota.item.danfe != null) {
            //     this.dialog = true;
            // }
        },
        trocaCampoCpfCnpjPrestador: function(e, v) {
            if (!v || (v && v.length == 0)) {
                this.mask.cnpjPrestador = "";
            } else {
                if (this.trocaCPFCNPJ && v && v.length >= 12) {
                    this.mask.cnpjPrestador = "##.###.###/####-##";
                } else if (v && v.length <= 11) {
                    this.trocaCPFCNPJ = true;
                    this.mask.cnpjPrestador = "###.###.###-###";
                } else {
                    this.trocaCPFCNPJ = false;
                    this.mask.cnpjPrestador = "##.###.###/####-##";
                }
            }
        },
        trocaCampoCpfCnpjTomador: function(e, v) {
            if (!v || (v && v.length == 0)) {
                this.mask.cnpjTomador = "";
            } else {
                if (this.trocaCPFCNPJ && v && v.length >= 12) {
                    this.mask.cnpjTomador = "##.###.###/####-##";
                } else if (v && v.length <= 11) {
                    this.trocaCPFCNPJ = true;
                    this.mask.cnpjTomador = "###.###.###-###";
                } else {
                    this.trocaCPFCNPJ = false;
                    this.mask.cnpjTomador = "##.###.###/####-##";
                }
            }
        },
    }
};
</script>
<style scoped>
.informe-rendimentos-div-file {
    border: 1px solid #8f7e88;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px!important;
}
.cont-ocr {
    position: absolute;
    background: #000000d4;
    width: 100vw;
    top: 0px;
    bottom: 0;
}

.load-ocr {
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
}

.ocrLink {
  color: teal;
  cursor: pointer;
}
.ocrLink:hover {
  text-decoration: underline;
}
h1,
h2 {
  font-weight: normal;
}
.descTable {
  background-color: rgb(0, 150, 136) !important;
  margin: 0 0 39px 0px;
}
.c_line_title {
  background-color: #499292;
  color: white;
  padding: 6px;
  position:relative;
}
.title_click {
  cursor: pointer;
}
.body_lista {
  background-color: #d7d7d7;
  border: thin solid black;
  min-height: 232px;
}
.body_lista_logins {
  max-height: 99px;
  overflow-y: scroll;
  background-color: #ececec;
  border: thin solid #c5c5c5;
}
.body_lista_logins::-webkit-scrollbar {
  width: 8px;
  height: 14px;
}
.body_lista ul {
  list-style: none;
}
.body_lista ul li {
  padding: 6px;
}

#table thead tr th {
    color: white!important;
}

.theme--light.v-table thead th {
    color: white!important;
}

@-webkit-keyframes loading {
  from {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loading {
  from {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.slide-fade-enter-active {
  opacity: 1;
  transition: all 0.3s cubic-bezier(0, 1.11, 0.83, 0.67);
}
.slide-fade-leave-active {
  opacity: 0;
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active em versões anteriores a 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.translate-y-fade-enter-active {
  opacity: 1;
  transition: all 3s cubic-bezier(0, 1.11, 0.83, 0.67);
}
.translate-y-fade-leave-active {
  opacity: 0;
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.translate-y-fade-enter, .translate-y-fade-leave-to
/* .slide-fade-leave-active em versões anteriores a 2.1.8 */ {
  transform: scaleY(1);
  opacity: 0;
}
.loading {
  animation-name: loading;
  animation: loading 2s infinite;
}
.valor_do_campo {
  font-size: 0.9em;
  color: #4d627b;
  opacity: 0.75;
  text-overflow: ellipsis !important;
  white-space: nowrap;
  overflow: hidden;
  min-width: 100px;
  width: 102px;
}
.uploadBtn {
        margin: 0;
        margin-bottom: -12px;
        background: linear-gradient(#ffffff, #f2f2f2);
        border: thin solid #6d7d80;
        padding: 0px 9px !important;
        height: 35px !important;
    }

    i {
  font-size: 18px;
}
.inputFile {
  display: inline-block;
}
.inputFile input[type="file"] {
  display: none;
}
.inputFile .custom-file-upload {
  border-radius: 11px;
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
small.typeArquivo {
  color: grey;
  font-weight: 700;
  margin-left: 5px;
}
.teal_bold {
  color: teal;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/pages/loggedArea/informeRendimentos/InformeRendimentos.vue